var _rect, _rect2, _circle, _path, _path2, _g, _g2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrontface({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 121,
    viewBox: "0 0 98 121",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 96,
    height: 119,
    rx: 4,
    fill: "#DADADA",
    fillOpacity: 0.15,
    stroke: "#817E7E",
    strokeOpacity: 0.6,
    strokeWidth: 0.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 82,
    height: 103,
    fill: "#FAFAFA"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 53,
    r: 35,
    fill: "#D8E8FD",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.9904 79.5625C30.9803 79.5625 16.3802 94.081 16.3802 111.99H81.6005C81.6005 94.081 67.0005 79.5625 48.9904 79.5625Z",
    fill: "#FFB719"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M65.9332 97.416H59.0103C58.6079 97.416 58.2816 97.7423 58.2816 98.1447V104.658C58.2816 104.912 58.4142 105.148 58.6314 105.28L62.0929 107.387C62.3256 107.529 62.6179 107.529 62.8506 107.387L66.3121 105.28C66.5293 105.148 66.6619 104.912 66.6619 104.658V98.1447C66.6619 97.7423 66.3356 97.416 65.9332 97.416Z",
    fill: "#F19100"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.3429 75.8008C43.3429 72.883 45.7083 70.5176 48.6261 70.5176C51.5439 70.5176 53.9093 72.883 53.9093 75.8008V79.08C53.9093 81.9979 51.5439 84.3632 48.6261 84.3632C45.7083 84.3632 43.3429 81.9979 43.3429 79.08V75.8008Z",
    fill: "#E0A070"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.941 55.9425C69.941 67.8151 60.3164 77.4397 48.4438 77.4397C36.5713 77.4397 26.9467 67.8151 26.9467 55.9425C26.9467 44.0699 36.5713 34.4453 48.4438 34.4453C60.3164 34.4453 69.941 44.0699 69.941 55.9425Z",
    fill: "#E0A070"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0261 62.439C67.0261 61.4328 67.8418 60.6172 68.8479 60.6172C69.8541 60.6172 70.6697 61.4328 70.6697 62.439V63.6535C70.6697 64.6597 69.8541 65.4753 68.8479 65.4753C67.8418 65.4753 67.0261 64.6597 67.0261 63.6535V62.439Z",
    fill: "#E0A070"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8536 62.439C25.8536 61.4328 26.6693 60.6172 27.6754 60.6172C28.6816 60.6172 29.4972 61.4328 29.4972 62.439V63.6535C29.4972 64.6597 28.6816 65.4753 27.6754 65.4753C26.6693 65.4753 25.8536 64.6597 25.8536 63.6535V62.439Z",
    fill: "#E0A070"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M38.0849 31.3122C43.7314 29.7677 49.1303 30.1097 54.022 33.4356C58.9137 36.7614 57.4927 34.2932 63.5615 35.4752C69.6303 36.6573 75.7833 52.3048 69.7041 52.6898C63.6248 53.0749 59.5072 45.3764 58.1317 42.118C40.9884 51.4918 34.94 45.5826 30.99 47.2831C27.0401 48.9837 25.6332 49.4648 26.1743 43.7029C26.6852 38.262 31.0267 33.2428 38.0849 31.3122Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0636 56.2443C40.0636 55.8419 40.3899 55.5156 40.7923 55.5156C41.1948 55.5156 41.521 55.8419 41.521 56.2443V58.0661C41.521 58.4686 41.1948 58.7949 40.7923 58.7949C40.3899 58.7949 40.0636 58.4686 40.0636 58.0661V56.2443Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55.3667 56.2443C55.3667 55.8419 55.693 55.5156 56.0954 55.5156C56.4979 55.5156 56.8241 55.8419 56.8241 56.2443V58.0661C56.8241 58.4686 56.4979 58.7949 56.0954 58.7949C55.693 58.7949 55.3667 58.4686 55.3667 58.0661V56.2443Z",
    fill: "black"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.9632 65.6885C43.1803 65.4789 43.5263 65.4849 43.736 65.7021C44.5243 66.5185 45.9627 67.5031 47.6772 67.7879C49.3566 68.0669 51.3508 67.685 53.3406 65.6952C53.554 65.4818 53.9001 65.4818 54.1135 65.6952C54.3269 65.9087 54.3269 66.2547 54.1135 66.4682C51.8767 68.7049 49.529 69.2036 47.498 68.8662C45.5021 68.5346 43.8617 67.4059 42.9496 66.4613C42.74 66.2442 42.746 65.8982 42.9632 65.6885Z",
    fill: "black"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 19C17.7761 19 18 18.7761 18 18.5C18 18.2239 17.7761 18 17.5 18H14.5C14.2239 18 14 18.2239 14 18.5V21.5C14 21.7761 14.2239 22 14.5 22C14.7761 22 15 21.7761 15 21.5V19H17.5Z",
    fill: "black"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 19C80.2239 19 80 18.7761 80 18.5C80 18.2239 80.2239 18 80.5 18H83.5C83.7761 18 84 18.2239 84 18.5V21.5C84 21.7761 83.7761 22 83.5 22C83.2239 22 83 21.7761 83 21.5V19H80.5Z",
    fill: "black"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 87C17.7761 87 18 87.2239 18 87.5C18 87.7761 17.7761 88 17.5 88H14.5C14.2239 88 14 87.7761 14 87.5V84.5C14 84.2239 14.2239 84 14.5 84C14.7761 84 15 84.2239 15 84.5V87H17.5Z",
    fill: "black"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M80.5 87C80.2239 87 80 87.2239 80 87.5C80 87.7761 80.2239 88 80.5 88H83.5C83.7761 88 84 87.7761 84 87.5V84.5C84 84.2239 83.7761 84 83.5 84C83.2239 84 83 84.2239 83 84.5V87H80.5Z",
    fill: "black"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d",
    x: 41.3429,
    y: 68.5176,
    width: 14.5664,
    height: 17.8456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d",
    x: 24.9467,
    y: 32.4453,
    width: 46.9944,
    height: 46.9944,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrontface);
export default __webpack_public_path__ + "static/media/frontface.b7ce3bb0311333dd261694e78e2337f8.svg";
export { ForwardRef as ReactComponent };